import { render, staticRenderFns } from "./paymentAdviceModal.vue?vue&type=template&id=676f436a"
import script from "./paymentAdviceModal.vue?vue&type=script&lang=js"
export * from "./paymentAdviceModal.vue?vue&type=script&lang=js"
import style0 from "./paymentAdviceModal.vue?vue&type=style&index=0&id=676f436a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports